import * as Yup from "yup";


const validateSchema = (getValidationSchema) => {
    return (values) => {
        const validationSchema = getValidationSchema(values);
        try {
            validationSchema.validateSync(values, {abortEarly: false});
            return {}
        } catch (error) {
            return getErrorsFromValidationError(error)
        }
    }
};

const getErrorsFromValidationError = (validationError) => {
    const FIRST_ERROR = 0;
    return validationError.inner.reduce((errors, error) => {
        return {
            ...errors,
            [error.path]: error.errors[FIRST_ERROR],
        }
    }, {})
};

export function validate(validationSchema, values) {
    return validateSchema(validationSchema)(values);
}
export function validateConfig(validationConfig, values){
    return Object.keys(validate(buildValidationSchema(validationConfig), values)).length===0;
}

export function isValid(validationSchema, values){
    let errors = validate(validationSchema, values);
    return Object.keys(errors).length === 0;
}

export function buildValidationSchema(validationConfig) {
    return function (values) {
        let yup_shape = {};
        validationConfig.forEach(fieldConfig => {

            let yupObj = fieldConfig.yup || null;
            if (yupObj == null) {

                if (fieldConfig.dataType === "email")
                    yupObj = Yup.string().email('Invalid email address');
                else
                    yupObj = Yup.string();

                yupObj = yupObj.min(0, "Must be at least 1");
            }

            if (fieldConfig.yupMatch !== undefined) {
                yupObj = yupObj.oneOf([values[fieldConfig.yupMatch]], 'Passwords must match')
            }


            yup_shape[fieldConfig.dataField] = yupObj;
        });
        return Yup.object().shape(yup_shape);
    };
}

const ValidationHelper = {
    validate,
    validateConfig,
    isValid,
    buildValidationSchema
};

export default ValidationHelper;
